export default __webpack_public_path__ + "663c654951b8e68f95f7cbbd5411a636.gif";